<template>
  <Stack
    class="tw-py-7 tw-max-w-prose tw-mx-auto"
    gap="4"
  >
  <div class="columns is-vcentered">
    <div class="column is-three-quarters">
      <Title
        tag="h2"
        size="12"
      >
        Notes
      </Title>
    </div>
    <div class="column is-one-quarter">
      <div class="buttons is-right">
        <Button
          variant="primary"
          size="4"
          icon-only="fas fa-plus"
          @click="showCreateModal = true"
        >
          New Note
        </Button>
      </div>
    </div>
    </div>

    <StakeModal v-model="showCreateModal">
      <CreateEditNote
        :entity-external-id="entityExternalId"
        @refresh="fetchNotes"
        @close="showCreateModal = false"
      />
    </StakeModal>

    <TextInput
      v-model="query"
      placeholder="Search notes"
      icon-before="fas fa-search"
      :loading="loading"
    />

    <div v-if="query && notes.length === 0">
      Nothing found for <strong>{{ query }}</strong>
    </div>

    <ul class="tw-flex tw-flex-col tw-gap-4">
      <li
        v-for="note in notes"
        :key="note.external_id"
      >
        <NoteCard
          :note="note"
          :entity-external-id="entityExternalId"
          @refresh="fetchNotes"
        />
      </li>
    </ul>
  </Stack>
</template>


<script setup>
import { ref, watch, defineProps, onMounted } from 'vue';
import { debounce } from 'lodash';
import { fetchWrapper } from '@frontend/shared/fetch-wrapper.js';

import { Button, Stack, TextInput, Title } from '@stakeui';
import StakeModal from '@stakeui/StakeModal.vue';

import CreateEditNote from '@features/notes/components/CreateEditNote.vue';
import NoteCard from '@features/notes/components/NoteCard.vue';


import { useAdvisorStore } from '@frontend/ui/stores/advisorStore.js';
const advisorStore = useAdvisorStore();


const props = defineProps({
  entityExternalId: {
    type: String,
    required: true,
  },
});


const showCreateModal = ref(false);
const notes = ref([]);
const query = ref('');
const loading = ref(false);


const debouncedFetchNotes = debounce(() => {
  fetchNotes();
}, 300);


watch(query, () => {
  debouncedFetchNotes();
});


const fetchNotes = async () => {
  const url = new URL(`/api/v1/entities/${props.entityExternalId}/notes`, window.location.origin);

  if (query.value) {
    url.searchParams.append('query', query.value);
  }

  loading.value = true;

  const res = await fetchWrapper(url.toString(), {
    method: 'GET',
    headers: advisorStore.headers,
  });
  loading.value = false;

  const data = await res.json();
  notes.value = data;

  showCreateModal.value = false;
};


onMounted(() => {
  fetchNotes();
});

</script>
